import { parseISO } from "date-fns";
export const DATE_REGEX = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{3,6})?(Z|([+-])(\d{2}):(\d{2}))?$/;
// Nefunguje v hloubce
export function transformProps(props) {
    return Object.fromEntries(Object.entries(props).map(([key, value]) => [key, transformationReviver(key, value)]));
}
export function transformPropsDeep(input) {
    if (Array.isArray(input)) {
        return input.map(transformPropsDeep);
    }
    if (input instanceof Set) {
        return new Set(Array.from(input).map(transformPropsDeep));
    }
    if (input instanceof Map) {
        return new Map(Array.from(input.entries()).map(([k, v]) => [transformPropsDeep(k), transformPropsDeep(v)]));
    }
    if (input !== null && typeof input === "object" && Object.prototype.toString.call(input) === "[object Object]") {
        return Object.fromEntries(Object.entries(input).map(([key, value]) => [key, transformPropsDeep(value)]));
    }
    return transformationReviver("", input);
}
export function transformationReviver(key, value) {
    if (typeof value !== "string") {
        return value;
    }
    if (DATE_REGEX.test(value)) {
        if (import.meta.env.DEV) {
            console.log(`${key} upraven jako čas!`);
        }
        return parseISO(value);
    }
    return value;
}
export function transformJSONString(value) {
    return JSON.parse(value, (key, value) => transformationReviver(key, value));
}
